var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"max-w-sm flex items-center justify-center text-center flex-col mx-auto mt-4 mb-4"},[_c('div',{staticClass:"my-4"},[_vm._v("You're done! No suspected duplicates found.")]),_c('img',{attrs:{"src":"/img/undraw_finish_line.svg"}})])
}]

export { render, staticRenderFns }